import './NossaLinha.css';

const CARDS = [
  {
    icon: '🧵',
    title: 'Algodão Premium',
    body: 'Tecidos de qualidade selecionados para máximo conforto no dia a dia, pensados para durar e manter a forma lavagem após lavagem.',
  },
  {
    icon: '🎨',
    title: 'Estampas Exclusivas',
    body: 'Designs autorais que celebram o amor pelos animais. Cada estampa conta uma história e carrega o compromisso social da marca.',
  },
  {
    icon: '✂️',
    title: 'Produção Artesanal',
    body: 'Fabricação transformando cuidado, tempo e criatividade em peças únicas cheias de significado.',
  },
];

export default function NossaLinha() {
  return (
    <section id="linha" className="linha">
      <div className="linha__inner">
        <div className="text-center">
          <span className="section-tag">Nossa Linha</span>
          <h2 className="section-title">Moda com propósito</h2>
          <p className="section-subtitle">
            Roupas desenvolvidas com foco no conforto, feitas em algodão de qualidade,
            com estampas exclusivas que refletem o amor pelos animais e o compromisso
            social da marca.
          </p>
        </div>

        <div className="linha__cards">
          {CARDS.map((c) => (
            <div key={c.title} className="linha__card">
              <div className="linha__card-icon">{c.icon}</div>
              <h3 className="linha__card-title">{c.title}</h3>
              <p className="linha__card-body">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
